import Cookies from "js-cookie";
import { useMemo } from "react";
import { clearInterviewData } from "./interview-cleanup";
import { messages } from "../submodules/Inventory-Module-Types/src";
import { CookiesExistence, SessionStorageExistence } from "../submodules/Inventory-Module-Types/src/utils/storage";
import { setAuthorization, setAuthorizationProctoring } from "../api-client";
export const MAIN_INSTRUCTION_DATA = "mainInstructionData";
export const MAIN_SESSION_INTERVIEW_META_DATA = "mainSessionInterviewMetaData";
export const MAIN_ATTEMPT = "mainAttempt";
export function useCrossOrigin() {
    // --- New logic: Check for query param 'data' and store in sessionStorage if present ---
    // const params = new URLSearchParams(window.location.search);
    // let payload: any = {};
    // if (params.get("data") && !sessionStorage.getItem("token")) {
    //   let dataString = params.get("data")!;
    //   // Try decoding up to 2 times if needed
    //   for (
    //     let i = 0;
    //     i < 2 && dataString[0] !== "{" && dataString[0] !== "[";
    //     i++
    //   ) {
    //     dataString = decodeURIComponent(dataString);
    //   }
    //   // Remove extra quotes if present
    //   if (dataString[0] === '"' && dataString[dataString.length - 1] === '"') {
    //     dataString = dataString.slice(1, -1);
    //   }
    //   try {
    //     payload = JSON.parse(dataString);
    //   } catch (e) {
    //     payload = {};
    //   }
    // } else {
    //   params.forEach((value, key) => {
    //     payload[key] = value;
    //   });
    // }
    // if (payload.token && payload.userId) {
    //   if (!payload.app) payload.app = window.location.origin;
    //   sessionStorage.setItem("token", payload.token);
    //   sessionStorage.setItem("userId", payload.userId);
    //   sessionStorage.setItem(
    //     messages.SESSION_INTERVIEW_META_DATA,
    //     JSON.stringify(payload)
    //   );
    //   // Optionally, you can clean up the URL here if needed
    // } else {
    //   // console.log("no payload", params);
    // }
    // // --- End new logic ---
    const checkData = () => {
        const cookieData = CookiesExistence(messages.COOKIES_ASSESSMENT_META_DATA);
        const sessionData = SessionStorageExistence(messages.SESSION_INTERVIEW_META_DATA);
        console.log("cookieData", cookieData);
        console.log("sessionData", sessionData);
        const mainInstructionData = sessionStorage.getItem(MAIN_INSTRUCTION_DATA);
        const mainAttempt = sessionStorage.getItem(MAIN_ATTEMPT);
        if (mainInstructionData && mainAttempt) {
            const mainSessionInterviewMetaData = sessionStorage.getItem(MAIN_SESSION_INTERVIEW_META_DATA);
            sessionStorage.setItem(messages.SESSION_INTERVIEW_META_DATA, mainSessionInterviewMetaData);
            sessionStorage.setItem("attempt", mainAttempt);
        }
        if (cookieData.isExist) {
            const assessmentConfigData = cookieData.data;
            // Clear any existing interview data before setting new data
            clearInterviewData();
            setAuthorization(assessmentConfigData.token);
            setAuthorizationProctoring(assessmentConfigData.token);
            sessionStorage.setItem(messages.SESSION_INTERVIEW_META_DATA, JSON.stringify(assessmentConfigData));
            sessionStorage.setItem("token", assessmentConfigData.token);
            sessionStorage.setItem("userId", assessmentConfigData.userId);
            const domain = window.location.hostname.includes("localhost")
                ? "localhost"
                : ".skilliq.co";
            if (assessmentConfigData.aiCoachV2RedirectUrl) {
                Cookies.set("redirect-on-app", assessmentConfigData.aiCoachV2RedirectUrl);
            }
            else {
                Cookies.set("redirect-on-app", assessmentConfigData.app);
            }
            Cookies.remove(messages.COOKIES_ASSESSMENT_META_DATA, { domain: domain });
            return assessmentConfigData;
        }
        if (sessionData.isExist) {
            let assessmentConfigData = sessionData.data;
            setAuthorization(assessmentConfigData.token);
            setAuthorizationProctoring(assessmentConfigData.token);
            return assessmentConfigData;
        }
    };
    return useMemo(() => checkData(), []);
}
